// Shared client+server derivation for per-ticket preview environments.
// A ticket host is `<label>-rdbaz-<n>.bazak.ai`; the -rdbaz-<n> suffix
// replaces dev's -dev suffix. See bazak-infra/docs/plans/2026-07-04-ticket-environments.md.
const TICKET_HOST_RE = /-rdbaz-(\d+)\.bazak\.ai$/;
const INCLUSTER_FQDN_RE = /^(https?:\/\/)([^./]+)\.([^./]+)(\.svc\.cluster\.local.*)$/;

export function getTicketEnvId(host: string | null | undefined): string | null {
  if (!host) return null;
  const bare = host.split(':')[0].toLowerCase();
  const match = bare.match(TICKET_HOST_RE);
  return match ? match[1] : null;
}

export function deriveTicketUrlFromDev(baseUrl: string, ticketId: string): string {
  const ns = `rdbaz-${ticketId}`;
  const incluster = baseUrl.match(INCLUSTER_FQDN_RE);
  if (incluster) {
    const [, scheme, service, , tail] = incluster;
    return `${scheme}${service}.${ns}${tail}`;
  }
  if (baseUrl.includes('-dev.bazak.ai')) {
    return baseUrl.replace('-dev.bazak.ai', `-${ns}.bazak.ai`);
  }
  return baseUrl;
}

export function deriveTicketUrl(baseUrl: string, ticketEnvId: string | null): string {
  return ticketEnvId ? deriveTicketUrlFromDev(baseUrl, ticketEnvId) : baseUrl;
}

export function maybeDeriveTicketUrl({
  baseUrl,
  host,
}: {
  baseUrl: string;
  host: string | null | undefined;
}): string {
  return deriveTicketUrl(baseUrl, getTicketEnvId(host));
}
